export enum PageThemeTypeEnum {
  /** 默认：老版本首页 */
  DEFAULT = 'default',
  /** 橙色版首页 */
  ORANGE_THEME = 'orange',
  /** 蓝色版首页 */
  BLUE_THEME = 'blue',
}
